<template>
  <div>
    <OrderContainer ref="container" />

    <ConfirmDialog
      v-model="showConfirmLeavingReceiveOrder"
      title="Avbryte varemottak"
      icon="mdi-truck-delivery-outline"
      text="Du har ikke bekreftet varemottak for bestilling. Er du sikker på at du ønsker å avbryte varemottak for bestilling?"
      btnActionName="Ja"
      btnCloseName="Nei"
      @action="confirmLeave()"
      @close="close"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import OrderContainer from "@/components/projects/project/house/orders/order/container/OrderContainer.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  data() {
    return {
      showConfirmLeavingReceiveOrder: false,
      confirmedGoTo: "",
      confirmedLeaving: false,
    };
  },
  methods: {
    confirmLeave() {
      this.confirmedLeaving = true;

      if (window.location.pathname !== this.$route.path) {
        //User click back
        this.$router.replace(this.confirmedGoTo);
      } else {
        //User click go to
        this.$router.push(this.confirmedGoTo);
      }
    },
    close() {
      this.confirmedGoTo = "";
      this.confirmedLeaving = false;
      this.$router.go(1);
    },
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.showConfirmMessage && !this.confirmedLeaving) {
      this.confirmedGoTo = to.fullPath;
      this.showConfirmLeavingReceiveOrder = true;
    } else {
      this.confirmedGoTo = "";
      this.confirmedLeaving = false;
      next();
    }
  },
  computed: {
    ...mapGetters({ showConfirmMessage: "shared/showConfirmMessage" }),
  },
  components: {
    OrderContainer,
    ConfirmDialog,
  },
});
</script>
